import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-check-box-empty",
  "use": "svgIcon-check-box-empty-usage",
  "viewBox": "0 0 440.02 440.02",
  "content": "<symbol viewBox=\"0 0 440.02 440.02\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-check-box-empty\"><path d=\"m327.327 359.861h-267.327v-267.329h266.65l61.001-60h-387.651v387.327h387.327v-387.013l-60.677 59.686z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol